import { createAction, props } from '@ngrx/store';

import { IResidentFeedbackEligibility, IResidentFeedbackInput } from '../../models';

export const LoadResidentFeedbackEligibility = createAction(
  '[Resident Feedback Prompt] Load Eligibility'
);

export const LoadResidentFeedbackEligibilitySuccess = createAction(
  '[Resident Feedback Prompt] Load Eligibility Success',
  props<{ eligibility: IResidentFeedbackEligibility }>()
);

export const LoadResidentFeedbackEligibilityFailed = createAction(
  '[Resident Feedback Prompt] Load Eligibility Failed',
  props<{ error: Error }>()
);

export const SaveResidentFeedback = createAction(
  '[Resident Feedback Prompt] Save Resident Feedback',
  props<{ input: IResidentFeedbackInput }>()
);

export const SaveResidentFeedbackSuccess = createAction(
  '[Resident Feedback Prompt] Save Resident Feedback Success'
);

export const SaveResidentFeedbackFailed = createAction(
  '[Resident Feedback Prompt] Save Resident Feedback Failed',
  props<{ error: Error }>()
);

/** Set when the sheet is presented, so one session yields at most one prompt. */
export const MarkResidentFeedbackPromptShown = createAction(
  '[Resident Feedback Prompt] Mark Prompt Shown'
);
